// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"84d77df5","180":"84d77df5","201":"32609542"}[chunkId] + ".chunk.css";
};